import axios from 'axios';

const apiClient = axios.create({
  // Cambia esto por tu URL real
  baseURL: 'https://agentes.therealdevs.pro/index.php/',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para incluir el Token JWT automáticamente en cada petición
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Donde guardas tu JWT
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;